import Vue from "vue";
import * as types from "../mutation-types";
import {
  sale_order_items,
  update_order,
  get_all_items,
  get_apply_coupon_code,
  apply_promotion_code,
  update_order_status,
  void_order,
  void_item,
  get_table_status,
  split_sale,
} from "@/api/item";

import { update } from "sweetalert2";

const getDefaultState = () => {
  return {
    order_items: [],
    order_status: false,
    count_sale: 0,
    coupon_amount: 0,
  };
};

export const state = {
  loading: false,
  loading_more: false,
  loading_order: false,
  loading_void: false,
  loading_apply_promotion_code: false,
  loading_split_sale: false,
  promotion: {},
  data_split: null,
  items: [],
  order_items: [],
  order_status: false,
  order: {},
  order_qty: 0,
  meta: {},
  coupon_amount: 0,
  items_length: 0,
  order_type: null,
  sale: {},
  count_sale: 0,
  order_voided: {},
  void_items_status: false,
  order_modify: {},
  table_status: {},
  void_response: {},
};
export const getters = {
  loading: (state) => state.loading,
  loading_void: (state) => state.loading_void,
  loading_order: (state) => state.loading_order,
  loading_split_sale: (state) => state.loading_split_sale,
  data_split: (state) => state.data_split,
  promotion: (state) => state.promotion,
  loading_apply_promotion_code: (state) => state.loading_apply_promotion_code,
  loading_more: (state) => state.loading_more,
  items_length: (state) => state.items_length,
  items: (state) => state.items,
  meta: (state) => state.meta,
  table_status: (state) => state.table_status,
  order_items: (state) => state.order_items,
  order_status: (state) => state.order_status,
  order_qty: (state) => state.order_qty,
  order: (state) => state.order,
  coupon_amount: (state) => state.coupon_amount,
  order_type: (state) => state.order_type,
  sale: (state) => state.sale,
  count_sale: (state) => state.count_sale,
  order_voided: (state) => state.order_voided,
  order_modify: (state) => state.order_modify,
  void_items_status: (state) => state.void_items_status,
  void_response: (state) => state.void_response,
};
export const mutations = {
  [types.CLEAR_ORDER](state, payload) {
    state.order = {};
    state.sale = {};
    state.order_items = [];
  },
  [types.MODIFY_ORDER](state, payload) {
    state.order_modify = payload;
  },
  [types.ORDER](state, payload) {
    state.order = payload;
  },

  [types.VOID_ORDER](state, payload) {
    state.loading_void = true;
  },
  [types.VOID_ORDER_SUCCESS](state, payload) {
    state.order_voided = payload;
    state.loading_void = false;
  },
  [types.VOID_ORDER_FAILED](state, payload) {
    state.order_voided = {};
    state.loading_void = false;
  },
  [types.VOID_ITEM](state, payload) {
    state.loading_void = true;
  },
  [types.VOID_ITEM_SUCCESS](state, payload) {
    state.loading_void = false;
    state.void_response = payload.data.sale_item;
  },
  [types.VOID_ITEM_FAILED](state, payload) {
    state.loading_void = false;
  },
  [types.FETCH_ITEMS](state, payload) {
    state.loading = true;
  },
  [types.SET_COUNT_SALE](state, payload) {
    state.count_sale = payload;
  },
  [types.RESET_SALE_ITEM](state, payload) {
    state.sale = [];
  },
  [types.FETCH_MORE_ITEMS](state, payload) {
    state.loading_more = true;
  },
  [types.ORDER_TYPE](state, payload) {
    state.order_type = payload;
  },
  [types.FETCH_PRODUCT](state, payload) {
    state.loading = true;
    state.items = [];
  },
  [types.FETCH_PRODUCT_SUCCESS](state, payload) {
    state.loading = false;
    state.items = payload.items;
    state.meta = payload.meta;
    state.items_length = payload.items.length;
  },
  [types.FETCH_MORE_PRODUCT_SUCCESS](state, payload) {
    state.loading_more = false;
    _.map(payload.items, function (items) {
      state.items.push(items);
    });
    state.meta = payload.meta;
  },
  [types.FETCH_PRODUCT_ERROR](state, payload) {
    state.loading = false;
    state.items = [];
  },
  [types.FETCH_ORDER_QTY_SUCCESS](state, payload) {
    state.order_qty = payload;
  },
  [types.FETCH_ORDER_ITEMS_SUCCESS](state, payload) {
    // console.log(payload)
    const item = state.order_items.find(
      (item) => item.item_key === payload.item_key
    );

    if (item) {
      payload.quantity = item.quantity + state.order_qty;
      payload.item_amount =
        item.item_price_per_set * payload.quantity - payload.discount;
      if (item.sale_detail_id) {
        payload.sale_detail_id = item.sale_detail_id;
      }
      Object.assign(item, payload);
    } else {
      payload.item_amount =
        payload.item_price_per_set * payload.quantity - payload.discount;
      state.order_items.unshift(payload);
    }
  },
  [types.FETCH_ORDER_STATUS_SUCCESS](state, payload) {
    Object.assign(state, getDefaultState());
  },
  [types.RESET_ORDER_ITEMS_STATE](state, payload) {
    Object.assign(state, getDefaultState());
  },
  [types.FETCH_DELETE_ITEM_SUCCUSS](state, payload) {
    const id = state.order_items.map((item) => item.item_key).indexOf(payload);
    state.order_items.splice(id, 1);
  },
  [types.FETCH_MODIFIED_ORDER_ITEM](state, payload) {
    state.order_items = payload;
  },
  [types.FETCH_CATEGORY_FILTER_SUCCESS](state, payload) {
    state.items = payload.items;
    state.meta = payload.meta;
    state.items_length = payload.items.length;
  },
  [types.FETCH_CATEGORY_FILTER_ERROR](state, payload) {
    state.items = [];
  },
  [types.FETCH_UPDATE_ORDER_ITEM_SUCCESS](state, payload) {
    state.order_items = payload;
  },
  [types.POST_APPLY_COUPON_SUCCESS](state, payload) {
    state.coupon_amount = payload;
  },
  [types.POST_APPLY_COUPON_ERROR](state, payload) {
    state.coupon_amount = payload;
  },
  [types.SUBMIT_ORDER](state, payload) {
    state.order_status = false;
    state.loading_order = true;
  },
  [types.SUBMIT_ORDER_SUCCESS](state, payload) {
    state.order_status = true;
    state.order = payload.sale;
    state.sale = payload.sale;
    state.loading_order = false;
  },
  [types.SUBMIT_ORDER_FAIL](state, payload) {
    state.order_status = false;
    state.loading_order = false;
  },
  [types.APPLY_PROMOTIONCODE](state, payload) {
    state.loading_apply_promotion_code = true;
  },

  [types.APPLY_PROMOTIONCODE_ERROR](state, payload) {
    state.loading_apply_promotion_code = false;
    state.promotion = 0;
  },

  [types.APPLY_PROMOTIONCODE_SUCCESS](state, payload) {
    state.loading_apply_promotion_code = false;
    state.promotion = payload.promotion_amount || 0;
  },

  [types.FETCH_UPDATE_ORDER_STATUS](state, payload) {
    state.loading = true;
  },
  [types.FETCH_UPDATE_ORDER_STATUS_SUCCESS](state, payload) {
    state.loading = false;
    state.order_status = payload;
  },
  [types.FETCH_UPDATE_ORDER_STATUS_FAILED](state, payload) {
    state.loading = false;
    state.order_status = {};
  },

  [types.GET_TABLE_STATUS](state, payload) {},
  [types.GET_TABLE_STATUS_FAIL](state, payload) {
    state.table_status = {};
  },
  [types.GET_TABLE_STATUS_SUCCESS](state, payload) {
    state.table_status = payload;
  },
  SplitSale(state) {
    state.loading_split_sale = true;
  },
  SplitSaleFail(state) {
    state.data_split = null;
    state.loading_split_sale = false;
  },
  SplitSaleSuccess(state, payload) {
    state.loading_split_sale = false;
    state.data_split = payload;
  },
  updatePrintOrder(state) {
    state.order_items.forEach((v, index) => {
      state.order_items[index].quantity_print =
        state.order_items[index].quantity;
    });
  },
};
export const actions = {
  updatePrintQty({ commit }, payload) {
    commit("updatePrintOrder");
  },

  async updateOrder({ commit }, payload) {
    // commit('SplitSale');
    try {
      let data = await update_order(payload);
      // commit('SplitSaleSuccess',data);
    } catch (error) {
      // commit('SplitSaleFail');
      throw error;
    }
  },
  async SplitSale({ commit }, payload) {
    commit("SplitSale");
    try {
      let data = await split_sale(payload);
      commit("SplitSaleSuccess", data);
    } catch (error) {
      commit("SplitSaleFail");
      throw error;
    }
  },
  async voidOrder({ commit }, payload) {
    commit(types.VOID_ORDER);
    try {
      let data = await void_order(payload);
      commit(types.VOID_ORDER_SUCCESS, data.data);
    } catch (error) {
      let error_ = error.response;
      commit(types.VOID_ORDER_FAILED, error_);
      throw error;
    }
  },
  async voidItemInInvoice({ commit }, payload) {
    commit(types.VOID_ITEM);
    try {
      let data = await void_item(payload);
      commit(types.VOID_ITEM_SUCCESS, data);
    } catch (error) {
      commit(types.VOID_ITEM_FAILED);
      throw error;
    }
  },
  setCountSalePending({ commit }, payload) {
    commit(types.SET_COUNT_SALE, payload);
  },
  resetSaleItems({ commit }, payload) {
    commit(types.RESET_SALE_ITEM, payload);
  },
  async setOrderType({ commit }, payload) {
    commit(types.ORDER_TYPE, payload);
  },
  async postApplyCouponCode({ commit }, payload) {
    try {
      const data = await get_apply_coupon_code(payload);
      commit(types.POST_APPLY_COUPON_SUCCESS, data.coupon_amount);
    } catch (error) {
      let error_ = error.response;
      commit(types.POST_APPLY_COUPON_ERROR, 0);
    }
  },
  async fetchUpdateOrderItem({ commit, getters }, payload) {
    let updateItem = payload;
    let find = _.findIndex(getters.order_items, function (e) {
      return e.item_key == updateItem.item_old_key;
    });

    // check if exist key
    //   let find_update_by_key = _.findIndex(getters.order_items, function (e) {
    //     return e.item_key === updateItem.item_key;
    //   });

    if (find > -1) {
      getters.order_items[find].note = updateItem.note;
      getters.order_items[find].discount = Number(updateItem.discount);
      getters.order_items[find].item_discount_amount =
        updateItem.item_discount_amount;
      getters.order_items[find].item_discount_percent =
        updateItem.item_discount_percent;
      getters.order_items[find].quantity = Number(updateItem.quantity);
      getters.order_items[find].item_amount =
        Number(getters.order_items[find].item_price_per_set) *
          Number(getters.order_items[find].quantity) -
        Number(updateItem.discount);
    } else {
      update.item_amount =
        Number(updateItem.item_price_per_set) * Number(updateItem.quantity) -
        Number(updateItem.discount);
      getters.order_items[find] = updateItem;
    }
  },

  async applyPromotionCode({ commit }, payload) {
    commit(types.APPLY_PROMOTIONCODE);
    try {
      let data = [];

      _.forEach(getters.order_items, function (el) {
        let item = {
          item_id: el.item_id,
          qty: el.quantity,
          price: el.item_amount,
          options: [],
          note: el.note,
          discount: el.discount,
          percentage: el.item_discount_percent,
          sale_detail_id: el.sale_detail_id || null,
        };
        _.forEach(el.options, function (ell) {
          let options = {
            option_id: ell.option_id,
            optionvalues: [],
          };
          _.forEach(ell.optionvalues, function (elll) {
            options.optionvalues.push({ id: elll.option_value_id });
          });
          item.options.push(options);
        });
        data.items.push(item);
      });

      payload.items = data;

      let response = await apply_promotion_code(payload);
      commit(types.APPLY_PROMOTIONCODE_SUCCESS, response);
    } catch (error) {
      commit(types.APPLY_PROMOTIONCODE_ERROR);
    }
  },
  async fetchItemsByCategory({ commit }, payload) {
    commit(types.FETCH_ITEMS);
    try {
      const data = await get_all_items(payload);
      commit(types.FETCH_PRODUCT_SUCCESS, data.data);
    } catch (error) {
      let error_ = error.response;
      commit(types.FETCH_PRODUCT_ERROR, error_);
    }
  },
  async fetchProduct({ commit }, payload) {
    commit(types.FETCH_ITEMS);
    try {
      const input = {
        type_id: payload.type_id,
        type: payload.type,
        search: payload.search,
        page: payload.page,
        limit: payload.limit,
      };
      const data = await get_all_items(input);
      commit(types.FETCH_PRODUCT_SUCCESS, data.data);
    } catch (error) {
      let error_ = error.response;
      commit(types.FETCH_PRODUCT_ERROR, error_);
    }
  },
  async fetchMoreItems({ commit }, payload) {
    commit(types.FETCH_MORE_ITEMS);
    try {
      const input = {
        type_id: payload.type_id,
        type: payload.type,
        search: payload.search,
        page: payload.page,
        limit: payload.limit,
        category_id: payload.category_id,
      };
      const data = await get_all_items(input);
      commit(types.FETCH_MORE_PRODUCT_SUCCESS, data.data);
    } catch (error) {
      let error_ = error.response;
      commit(types.FETCH_PRODUCT_ERROR, error_);
    }
  },
  async fetchOrderQty({ commit }, payload) {
    commit(types.FETCH_ORDER_QTY_SUCCESS, payload);
  },
  fetchOrderItem({ commit }, payload) {
    let item = {};
    _.forEach(payload, function (el) {
      item = el;
    });
    commit(types.FETCH_ORDER_ITEMS_SUCCESS, item);
  },
  async submitOrder({ commit, getters }, payload) {
    let data = {
      items: [],
      total: payload.total,
      sub_total: payload.sub_total,
      discount: payload.discount,
      percentage: payload.percentage,
      coupon: payload.coupon,
      note: payload.note,
      type_id: payload.type_id,
      type: payload.type,
      is_paid: payload.is_paid,
      currency_id: payload.currency_id,
      exchangerate: payload.exchangerate,
      customer_id: payload.customer_id,
      table_id: payload.location_id,
      order_type: getters.order_type,
      is_send_email: payload.is_send_email,
      promotion_code: payload.promotion_code,
      sale_id: payload.sale_id || null,
      removed_sale_details: payload.removed_sale_details,
      cash_received: payload.cash_received,
      number_split: payload.number_split || 0,
      payment_type_id: payload.payment_type_id || 0,
      data_cash_receive: payload.data_cash_receive,
    };
    _.forEach(getters.order_items, function (el) {
      let item = {
        item_id: el.item_id,
        qty: el.quantity,
        price: el.item_amount,
        options: [],
        note: el.note,
        discount: el.discount,
        percentage: el.item_discount_percent,
        sale_detail_id: el.sale_detail_id || null,
      };
      _.forEach(el.options, function (ell) {
        let options = {
          option_id: ell.option_id,
          optionvalues: [],
        };
        _.forEach(ell.optionvalues, function (elll) {
          options.optionvalues.push({ id: elll.option_value_id });
        });
        item.options.push(options);
      });
      data.items.push(item);
    });
    commit(types.SUBMIT_ORDER);
    try {
      let response = null;
      let message = "Order is created successfully!";
      let type = "success";
      if (data.sale_id) {
        response = await update_order(data);
        message = "Order is updated!";
        type = "info";
      } else {
        response = await sale_order_items(data);
      }
      commit(types.SUBMIT_ORDER_SUCCESS, response);

      Vue.notify({
        group: "notification",
        type: type,
        speed: 100,
        duration: 5000,
        text: message,
      });
    } catch (error) {
      commit(types.SUBMIT_ORDER_FAIL, error.response);
      throw error;
    }
  },
  async getItemsByName({ commit }, payload) {
    commit(types.FETCH_PRODUCT);
    try {
      const data = await get_all_items(payload);
      if (data) {
        commit(types.FETCH_PRODUCT_SUCCESS, data.data);
      }
    } catch (error) {
      commit(types.FETCH_PRODUCT_ERROR, error.response);
    }
  },
  async getOrderItemsStatus({ commit }, payload) {
    commit(types.FETCH_ORDER_STATUS_SUCCESS, payload);
  },
  async clear_order({ commit }, payload) {
    commit(types.RESET_ORDER_ITEMS_STATE, payload);
  },
  async deleteOrderItems({ commit }, payload) {
    commit(types.FETCH_DELETE_ITEM_SUCCUSS, payload);
  },
  async modifiedOrderItems({ commit }, payload) {
    commit(types.FETCH_MODIFIED_ORDER_ITEM, payload);
  },
  async UpdateOrderStatus({ commit }, payload) {
    commit(types.FETCH_UPDATE_ORDER_STATUS);
    try {
      const data = await update_order_status(payload);
      commit(types.FETCH_UPDATE_ORDER_STATUS_SUCCESS, data.data.item);
    } catch (error) {
      commit(types.FETCH_UPDATE_ORDER_STATUS_FAILED);
      console.log(error);
      throw error;
    }
  },
  clear_invoice({ commit }) {
    commit(types.CLEAR_ORDER);
  },
  set_invoice({ commit }, payload) {
    commit(types.ORDER, payload);
  },
  modifyOrder({ commit }, payload) {
    commit(types.MODIFY_ORDER, payload);
  },

  async getTableStatus({ commit }, payload) {
    commit(types.GET_TABLE_STATUS);
    try {
      const data = await get_table_status(payload);
      commit(types.GET_TABLE_STATUS_SUCCESS, data.data);
    } catch (error) {
      commit(types.GET_TABLE_STATUS_FAIL);
      console.log(error);
      throw error;
    }
  },
};
